const { EVENT_TYPE,  MIN_MAX, PERCENTILES } = require('../consts')

const queryMonthlyChartsEvents = (id, start, end) => {
  console.log(`id, start, end : ${id},'${start}','${end}'`);
  console.log('MIN_MAX', MIN_MAX);
  const q = `
      WITH raw_month AS (SELECT * FROM events
        WHERE patient_id=${id}  
        AND timestamp > '${start}' AND timestamp < '${end}'
        ),

        pulseRate AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.PPG} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.PPG} 
          AND value > ${MIN_MAX[EVENT_TYPE.PPG].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.PPG].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        respRate AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.RESPIRATION} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.RESPIRATION}
          AND value > ${MIN_MAX[EVENT_TYPE.RESPIRATION].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.RESPIRATION].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        respRateManual AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.RESPIRATION_MANUAL} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.RESPIRATION_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.RESPIRATION].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.RESPIRATION].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),
      
        oxygen AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.SPO2} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.SPO2}
          AND value > ${MIN_MAX[EVENT_TYPE.SPO2].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.SPO2].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        oxygenManual AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.SPO2_MANUAL} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.SPO2_MANUAL} 
          AND value > ${MIN_MAX[EVENT_TYPE.SPO2].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.SPO2].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),
      
        bloodPressureSystolic AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.SYSTOLIC} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.SYSTOLIC}
          AND value > ${MIN_MAX[EVENT_TYPE.SYSTOLIC].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.SYSTOLIC].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        bloodPressureSystolicManual AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.SYSTOLIC_MANUAL} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.SYSTOLIC_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.SYSTOLIC].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.SYSTOLIC].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        bloodPressureDiastolic AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.DIASTOLIC} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.DIASTOLIC}
          AND value > ${MIN_MAX[EVENT_TYPE.DIASTOLIC].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.DIASTOLIC].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}' 
          GROUP BY one_day
          ORDER BY one_day
        ),

        bloodPressureDiastolicManual AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.DIASTOLIC_MANUAL} as event_type,
              percentile_disc(${PERCENTILES.GENERAL_LOW}) within group (order by value::integer) as low,
              percentile_disc(${PERCENTILES.GENERAL_HIGH}) within group (order by value::integer) as high,
              round(avg(value)) as avg
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.DIASTOLIC_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.DIASTOLIC].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.DIASTOLIC].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}' 
          GROUP BY one_day
          ORDER BY one_day
        ),
      
        weight AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.WEIGHT} as event_type,
              last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.WEIGHT}
          AND value > ${MIN_MAX[EVENT_TYPE.WEIGHT].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.WEIGHT].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        weightManual AS (
          SELECT 
              time_bucket_gapfill('1 days', timestamp) AS one_day,
              ${EVENT_TYPE.WEIGHT_MANUAL} as event_type,
              last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.WEIGHT_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.WEIGHT].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.WEIGHT].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),
      
        glucose AS (
          SELECT 
            time_bucket_gapfill('1 days', timestamp) AS one_day,
            ${EVENT_TYPE.GLUCOSE} as event_type,
            last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.GLUCOSE}
          AND value > ${MIN_MAX[EVENT_TYPE.GLUCOSE].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.GLUCOSE].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        glucoseManual AS (
          SELECT 
            time_bucket_gapfill('1 days', timestamp) AS one_day,
            ${EVENT_TYPE.GLUCOSE_MANUAL} as event_type,
            last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.GLUCOSE_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.GLUCOSE].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.GLUCOSE].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        temperature AS (
          SELECT 
            time_bucket_gapfill('1 days', timestamp) AS one_day,
            ${EVENT_TYPE.TEMPRATURE} as event_type,
            last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.TEMPRATURE}
          AND value > ${MIN_MAX[EVENT_TYPE.TEMPRATURE].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.TEMPRATURE].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),

        temperatureManual AS (
          SELECT 
            time_bucket_gapfill('1 days', timestamp) AS one_day,
            ${EVENT_TYPE.TEMPRATURE_MANUAL} as event_type,
            last(value, timestamp) as value
          FROM raw_month
          WHERE event_type = ${EVENT_TYPE.TEMPRATURE_MANUAL}
          AND value > ${MIN_MAX[EVENT_TYPE.TEMPRATURE].MIN} 
          AND value < ${MIN_MAX[EVENT_TYPE.TEMPRATURE].MAX}
          AND timestamp > '${start}' AND timestamp < '${end}'
          GROUP BY one_day
          ORDER BY one_day
        ),
        
      candles AS (
        SELECT event_type,one_day as date,low,high,avg FROM pulseRate
        UNION 
        SELECT event_type,one_day as date,low,high,avg FROM respRate
        UNION 
        SELECT event_type,one_day as date,low,high,avg FROM respRateManual
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM oxygen
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM oxygenManual
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM bloodPressureSystolic
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM bloodPressureSystolicManual
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM bloodPressureDiastolic
        UNION
        SELECT event_type,one_day as date,low,high,avg FROM bloodPressureDiastolicManual
        ),
      
        spots AS(
          SELECT event_type,one_day as date, value FROM weight
          UNION 
          SELECT event_type,one_day as date, value FROM weightManual
          UNION 
          SELECT event_type,one_day as date, value FROM glucose 
          UNION 
          SELECT event_type,one_day as date, value FROM glucoseManual 
          UNION 
          SELECT event_type,one_day as date, value FROM temperature 
          UNION 
          SELECT event_type,one_day as date, value FROM temperatureManual 
        ),
      
        candles_jsons AS (
          SELECT 
            event_type,
            json_agg(Json_build_object('date',date::date,'event_type',event_type,'low',low,'high',high,'avg',avg) ORDER BY date)
          FROM candles  
          GROUP BY event_type	
          ),
          spots_jsons AS (
          SELECT 
            event_type,
            json_agg(Json_build_object('date',date::date,'event_type',event_type,'value',value) ORDER BY date)
          FROM spots  
          GROUP BY event_type	
        )
      
        SELECT 
          (SELECT json_object_agg(event_type,json_agg) AS jbo from candles_jsons) as candles,
          (SELECT json_object_agg(event_type,json_agg) AS jbo from spots_jsons) as spots
    `;
  return q;
};

module.exports = { queryMonthlyChartsEvents };
